import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { InvoicesRequest } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: InvoicesRequest) =>
    $actions.billing.getInvoices(dispatch, payload),
  );
};
